import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobPostList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    jobPostDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const jobPostSlice = createSlice({
  name: 'jobPost',
  initialState,
  reducers: {
    getJobPostList: (state, action) => {
        state.jobPostList.requesting = true;
        state.jobPostList.error = null;
        state.jobPostList.items = [];
        state.jobPostList.success = false;
        state.jobPostList.filters = action.payload;
    },
    getJobPostListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobPostList.requesting = false;        
        state.jobPostList.items = data;
        state.jobPostList.success = true; 
        state.jobPostList.pagination.current_page = current_page;
        state.jobPostList.pagination.per_page = per_page;
        state.jobPostList.pagination.total = total;
    },
    getJobPosttListFail: (state, action) => {        
        state.jobPostList.requesting = false;
        state.jobPostList.error = action.payload;
    },
    getJobPostDetails: (state) => {
        state.jobPostDetails.requesting = true;
        state.jobPostDetails.error = null;
        state.jobPostDetails.data = null;
        state.jobPostDetails.success = false; 
    },
    getJobPostDetailsSuccess: (state, action) => {
        state.jobPostDetails.requesting = false;
        state.jobPostDetails.data = action.payload;
        state.jobPostDetails.success = true; 
    },
    getJobPostDetailsFail: (state, action) => {        
        state.jobPostDetails.requesting = false;
        state.jobPostDetails.error = action.payload;
    },
    doJobPostCreate: (state) => {
        state.jobPostDetails.requesting = true;
        state.jobPostDetails.error = null;
        state.jobPostDetails.data = null;
        state.jobPostDetails.success = false; 
    },
    doJobPostUpdate: (state) => {
        state.jobPostDetails.requesting = true;
        state.jobPostDetails.error = null;
        state.jobPostDetails.data = null;
        state.jobPostDetails.success = false; 
    },
    doJobPostDelete: (state) => {
        state.jobPostDetails.requesting = true;
        state.jobPostDetails.error = null;
        state.jobPostDetails.data = null;
        state.jobPostDetails.success = false; 
    },
  },
})

export const { 
    getJobPostList, getJobPostListSuccess, getJobPostListFail,
    getJobPostDetails, getJobPostDetailsSuccess, getJobPostDetailsFail,
    doJobPostCreate, doJobPostUpdate, doJobPostDelete,
} = jobPostSlice.actions

export default jobPostSlice.reducer